import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Close extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <polygon points="15,2.4 13.6,1 8,6.6 2.4,1 1,2.4 6.6,8 1,13.6 2.4,15 8,9.4 13.6,15 15,13.6 9.4,8 " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Close.js